export default "__VITE_ASSET__e54675ce__"